import { EcommerceConfig } from './types';

export const defaultConfig: EcommerceConfig = {
  id: 'ecomm-shop-modular',
  title: 'Boutique E-commerce',
  description: 'Une boutique simple',
  shopName: 'Ma Boutique',
  shopDescription: 'Bienvenue dans ma boutique !',
  shopLogoUrl: '',
  shopLogoWidth: 140,
  shopLogoHeight: 80,
  currency: 'EUR',
  products: [],
  categories: [],
  theme: 'modern',          // conservé (non affiché)
  productCardSize: 'lg',
  // ✅ Apparence par défaut
  textColor: '#212529',
  backgroundColor: '#ffffff',
  fontFamily: 'inherit',
  buttonColor: '#0d6efd',
  titleColor: '#0d6efd',
  titleBackgroundColor: 'transparent',
  titleBold: true,
  titleItalic: false,
  shopDescriptionBackgroundColor: 'transparent',
  paymentMethods: {
    stripe: false,
    paypal: false,
    cash: false
  },
  showFilters: true,
  showSearch: true,
  showRatings: true,
  itemsPerPage: 6,
  showTermsLink: false, // ✅ Par défaut masqué
  globalTaxRate: 20,
  globalShippingCost: 0,
  allowedCountries: ['FR', 'BE', 'CH'],
  buyerConfirmationEmailTemplate: `
<img src="{{shopLogoUrl}}" alt="{{shopName}} Logo" style="max-width: 150px; margin-bottom: 20px;" />
<h1>Merci pour votre commande !</h1>
<p>Bonjour {{customerName}},</p>
<p>Nous avons bien reçu votre commande n°<strong>{{orderId}}</strong>, passée le {{transactionDate}}. Le montant total est de <strong>{{orderTotal}}</strong> (dont TVA : {{orderTax}}).</p>
<h3>Mode de livraison :</h3>
{{deliveryBlock}}
<h3>Détail de la commande :</h3>
{{productList}}
<p>Merci de votre confiance,<br>L'équipe de {{shopName}}</p>
`,
  buyerClickAndCollectEmailTemplate: `
<img src="{{shopLogoUrl}}" alt="{{shopName}} Logo" style="max-width: 150px; margin-bottom: 20px;" />
<h1>Votre commande est prête à être retirée !</h1>
<p>Bonjour {{customerName}},</p>
<p>Nous avons bien reçu votre commande n°<strong>{{orderId}}</strong>, passée le {{transactionDate}}. Le montant total est de <strong>{{orderTotal}}</strong> (dont TVA : {{orderTax}}).</p>
<h3>Retrait en boutique :</h3>
{{deliveryBlock}}
<h3>Détail de la commande :</h3>
{{productList}}
<p>Merci de votre confiance,<br>L'équipe de {{shopName}}</p>
`,
  sellerNotificationEmailTemplate: `
<img src="{{shopLogoUrl}}" alt="{{shopName}} Logo" style="max-width: 150px; margin-bottom: 20px;" />
<h1>Nouvelle vente !</h1>
<p>Vous avez reçu une nouvelle commande sur votre boutique {{shopName}} le {{transactionDate}}.</p>
<ul>
  <li><strong>Commande n° :</strong> {{orderId}}</li>
  <li><strong>Client :</strong> {{customerName}} ({{customerEmail}})</li>
  <li><strong>Montant total :</strong> {{orderTotal}}</li>
  <li><strong>Dont TVA :</strong> {{orderTax}}</li>
  <li><strong>Mode de paiement :</strong> {{paymentMethod}}</li>
  <li><strong>Mode de livraison :</strong> {{deliveryMethod}}</li>
</ul>
<h3>Détail de la commande :</h3>
{{productList}}
<p>Vous pouvez consulter les détails de la commande dans votre espace de gestion.</p>
  `,
  termsAndConditions: '',
  termsRgpd: '',
  clickAndCollect: {
    enabled: false,
    address: '',
    instructions: 'Vous recevrez un email lorsque votre commande sera prête à être retirée.'
  },
  // Modern display options
  displayMode: 'grid',
  columnsCount: 3,
  showWishlist: true,
  enableSort: true,
  notificationSettings: {
    notifFlexihubSeller: true,
    notifFlexihubClient: false,
    emailClient: true,
    emailSeller: true,
    whatsappClient: false,
    whatsappSeller: false,
    whatsappClientTemplate: 'Commande {{orderId}} confirmée. Total : {{orderTotal}}. Merci – {{shopName}}',
    whatsappSellerTemplate: 'Nouvelle vente #{{orderId}} de {{customerName}} — {{orderTotal}}.',
  },
};
